import React from 'react';
import ErrorBoundary from '../refresh/atoms/ErrorBoundary/ErrorBoundary';

const BannerWrapper = Component => {
  return props => (
    <ErrorBoundary renderBlank>
      <Component {...props} />
    </ErrorBoundary>
  );
};

export default BannerWrapper;
